<template>
  <toggle-list :data="channelsList" :model="model" />
</template>

<script>
import ToggleList from '@/common/components/form/ToggleList'
import { MessageTypeEnum } from '@/common/enum/MessageTypeEnum'

export default {
  name: 'UrlTrackingChannels',

  components: { ToggleList },

  props: {
    model: {
      type: Object,
      reuired: true
    }
  },

  computed: {
    channelsList() {
      return [
        {
          code: MessageTypeEnum.PUSH_WEB,
          name: this.$t('UrlTracking_Channels_WebPush'),
          qaId: 'web-push'
        },
        {
          code: MessageTypeEnum.INBOX,
          name: this.$t('UrlTracking_Channels_Inbox'),
          qaId: 'inbox'
        },
        {
          code: MessageTypeEnum.ON_SITE,
          name: this.$t('UrlTracking_Channels_Onsite'),
          qaId: 'on-site'
        },
        {
          code: MessageTypeEnum.EMAIL,
          name: this.$t('UrlTracking_Channels_Email'),
          qaId: 'email'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/components/UrlTrackingChannels.vue